import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Button from '@skippay/core/components/Button';
import { size } from '@skippay/core/styles/spacing';
import { color, transition } from '@skippay/core/styles/variables';
import { shouldForwardProp } from '@skippay/core/utils/emotionUtils';

const breakpoint = 1160;
const mediaMin = `screen and (min-width: ${breakpoint}px)`;
const mediaMax = `screen and (max-width: ${breakpoint - 1}px)`;

export const SNavbar = styled.div<{ isOpen: boolean }>`
	position: absolute;
	left: 0;
	top: 100%;
	margin: 0;
	z-index: -1;
	width: 100%;
	background-color: ${color('white')};
	box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.08);
	transform: translateY(-100%);
	transition: all ${transition('base')};
	${({ isOpen }) =>
		isOpen &&
		css`
			display: flex;
			max-height: calc(100vh - ${size(15)});
			overflow: visible;
			overflow-y: auto;
			transform: translateY(0);
		`};
	@media ${mediaMin} {
		position: relative;
		z-index: 10;
		box-shadow: none;
		border: 0;
		max-height: 100vh;
		transform: none;
	}
`;

export const SHamburger = styled.div`
	@media ${mediaMin} {
		display: none;
	}
`;

export const SMenu = styled.ul`
	left: 0;
	top: 100%;
	z-index: -1;
	width: 100%;
	background-color: ${color('white')};
	display: table;
	list-style-type: none;
	margin: 0;
	padding: 0;
	@media ${mediaMin} {
		position: relative;
		z-index: 10;
		box-shadow: none;
		border: 0;
		max-height: 100vh;
		transform: none;
		display: flex;
		align-items: center;
	}
`;

export const SButton = styled(Button, {
	shouldForwardProp: (prop) => shouldForwardProp(['isLast'], prop),
})<{ isLast?: boolean }>`
	padding-left: ${size(4)};
	padding-right: ${size(4)};
	@media ${mediaMax} {
		width: 100%;
		${({ isLast }) =>
			isLast &&
			css`
				margin-bottom: ${size(6)};
			`}
	}
`;

export const SAvatar = styled.div`
	height: ${size(12)};
	width: ${size(12)};
	display: none;
	margin-right: ${size(5)};
	position: relative;
	top: -1px;
	color: ${color('light-gray-700')};

	svg {
		height: ${size(12)};
		width: ${size(12)};
	}

	@media ${mediaMin} {
		display: inline-block;
	}
`;

export const SButtonContainer = styled.li<{ single?: boolean }>`
	flex: 1;
	padding: ${({ single }) =>
		single ? `${size(2)} ${size(5)} 0 ${size(5)}` : `${size(3)} ${size(5)} 0`};
	text-align: right;
	@media ${mediaMin} {
		padding: 0;
	}
`;

export const STopButton = styled(Button)`
	padding: ${size(2)} ${size(4)};
	margin-right: ${size(2)};

	@media ${mediaMax} {
		width: auto;
	}
`;
